export default {
  appTitle: 'Arcaea - 創新立體節奏遊戲',
  appDescription: '在那失落世界的旋律爭鬥中，那束和藹的白色光芒正等待著你。創新立體節奏遊戲.',
  hrefLang: 'zh_Hant',
  confirm: '確認',
  cancel: '取消',
  menu: {
    songRanking: '樂曲排名',
    story: '故事',
    goods: '周邊',
    login: '登入',
    account: '我的賬號'
  },
  footer: {
    copyright: '© 2021 lowiro',
    contact: '聯繫我們',
    terms: '服務條款',
    derivativeWorks: '二次創作管理條例',
    privacyPolicy: '隱私權政策',
    streamingGuidelines: '直播準則'
  },
  homepage: {
    artist: '作曲家',
    artwork: '封面繪師',
    songDescription: '在遊戲中可玩到的部分精選曲目'
  },
  account: {
    login: '登入',
    logout: '登出',
    errorLogin: '登入失敗。請檢查您的賬號名稱與密碼。',
    username: '賬號名稱',
    checking: '檢測中...',
    changeUsername: '更改賬號名',
    nameUnavailable: '名稱已被註冊。請使用別的名稱。',
    nameInvalid: '使用者名稱必須為 3~15 碼的英數字元、大小寫有別。',
    email: 'EMAIL',
    changeEmail: '更換電子信箱',
    errorEmailUnavailable: '此電子信箱已被註冊過。請使用其他電子信箱',
    memories: '記憶源點',
    buyMore: '購買',
    passwordReset: '重置密碼',
    enterEmail: '請輸入您的電子信箱地址',
    submit: '提交',
    usernameEmailID: '賬號名稱、電子信箱或者賬號ID',
    forgotPassword: ' 忘記密碼？?',
    errorInvalidEmail: '請輸入有效的信箱地址',
    errorUnknownEmail: '目前無賬號正在使用此此信箱地址',
    requestForgotSuccess: '一個鏈接已發送至您的信箱。請點擊鏈接來重置密碼。',
    newPassword: '請輸入新密碼',
    newPasswordConfirm: '確認密碼',
    passwordResetInput: '新密碼',
    passwordResetConfirm: '確認密碼',
    passwordResetSuccess: '密碼變更成功',
    errorMismatchPassword: '密碼與確認欄不符',
    errorInvalidPassword: '密碼至少是八位數字',
    errorInvalidResetToken: '無效的鏈接。請嘗試獲取新的連接。',
    password: '密碼',
    loginCaps: '登入',
    creditCard: '信用卡',
    purchaseMemories: '購買記憶源點',
    wouldLikePurchase: '購買<span class="bold">{amount}記憶源點</span>?',
    nameChangeWarn: '需要消費<span class="bold highlight-color">{amount}記憶源點</span>。<br/>確定要這麼做嗎？',
    payUsing: '付款方式',
    proccessingPayment: '正在處理',
    purchase: '購買',
    purchaseFailed: '購買失敗',
    purchaseFailedDescription: '您的購買沒有完成。 <br/>請再試一次。',
    purchaseComplete: '購買完成',
    justAdded: '您已完成購買 {amount} 記憶源點。',
    thankYou: '感謝您的購買！',
    Account: '賬號',
    backToAccount: '返回賬號',
    currentMemories: '現有記憶源點',
    usernameCost: '更改賬號名將消費<span class="bold">{amount} 記憶源點</span>。',
    change: '更改',
    cancel: '取消',
    newName: '新賬號名',
    newNameConfirm: '您的用戶名將更改為：',
    newEmailConfirm: '您的電子郵箱將更改為：',
    newEmail: '新的電子信箱',
    emailChangeWarn: '你確定要將電子信箱更換為<b>{email}</b>嗎?',
    checkInbox: '請您於收件箱中查看驗證超連結',
    verifyingEmail: '驗證中...',
    verifyEmailSuccess: '電子信箱修改成功',
    errorVerifyEmail: '電子信箱修改失敗，請重新嘗試',
    confirmPaymentChina: `在進行此付款服務前，我確認我居住于中華人民共和國（PRC）領土。<br/>在PRC境外使用此付款服務可能導致我的賬號被凍結。`,
    agree: '同意',
    version: '版本{version}',
    deleteUser: '刪除賬號的請求確認',
    verifyDeleteUserSuccess: '你的Arcaea賬號已被成功刪除',
    errorVerifyDeleteUser: '賬號未能被成功刪除，請重試',
    verifyingDeleteUser: '驗證中...',
    selectYourRegion: '選擇地區',
    ensureSelectRegion: '在購買記憶源點之前，請確保您所選擇的付款方式的來源地區和您選擇的地區一致。',
    selectRegionConfirm: '已選擇的地區'
  },
  goods: {
    originalSoundtracks: '原聲音樂',
    diverseDirect: 'DIVERSE DIRECT',
    tanoc: 'TANO*C STORE',
    amazon: 'Amazon.co.jp',
    lineHeader: 'Arcaea官方LINE貼圖',
    lineText1: '使用你最喜歡的Arcaea角色，讓聊天更可愛更多采！',
    lineButton: '前往 LINE STORE'
  },
  songRanking: {
    freeMusic: '免費樂曲',
    paidMusic: '收費樂曲',
    title: '標題',
    artist: '作曲家',
    new: 'New'
  },
  purchase: {
    sorryNotSupported: '非常抱歉，Arcaea官網暫不支持從您所在的地區購買。',
    memoryWithBonus: '{amount} + {bonusAmount}（附贈）',
    priceCurrencyFront: '{currency}{amount}',
    priceCurrencyBack: '{amount}{currency}'
  },
  story: {
    slide1: {
      text: `兩個少女前往探索一個支離破碎的世界。那裡伴隨著一個聲音：一段塵封的過往即將被揭開...<br/>
<br/>
她們從這個除了廢墟一無所有的世界中醒來，卻絲毫不記得這裡曾發生過的一切。這一刻她們才發現，自己也不過是虛無的存在。<br/>
而接下來，她們會發現一個名叫Arcaea的物體。它由空中漂浮著玻璃質感般的碎片所積聚而成，而這每一塊碎片，都包含著來自過去的鮮活回憶。<br/>`,
    },
    slide2: {
      text: `這些碎片向兩個少女身邊靠攏，似乎就像是它們在選擇讓誰來體驗這段塵封的記憶。<br/>
而少女們也通過自己的方式，體驗到了完全不同的過去。<br/>
<br/>
<i>這些玻璃反射出了另一個純潔的世界。她從中看見海洋、都市、火焰、光芒；美好的景象目不暇接。她抬起了自己的手，試圖去抓住它們，開心地笑了出來。</i><br/>
<br/>
<i>就像透過火車車窗看外頭稍縱即逝的景色一般，\n她瞧見了陰雨的景象。下一次是豔陽。再下一次是死亡。她厭惡地遠離了這些碎片。</i><br/>
      `
    },
    slide3: {
      text: `兩個少女在探索著支離破碎的世界中逐漸解鎖那塵封的過去。<br/>
<br/>
一側是光，另一側是對立。<br/>
<br/>
她們在Arcaea世界中所探索的一切會改變她們嗎？<br/>
<br/>
<i>這美妙而又簡簡單單的世界，只需要令人感到愉快就足够了。沒錯，無需多求。</i><br/>
<br/>
<i>但無論這些碎片在反射什麼……她從中未見到一絲光芒。哪怕是最小的火花，都會在一瞬間消失於她的視線。</i><br/>
<br/>
而這之後，在旅途的盡頭，她們又會變成誰？
`,
    }
  },
  links: {},
  countries: [
    { "id": 4, "name": "阿富汗", "a2": "af" },
    { "id": 248, "name": "奧蘭", "a2": "ax" },
    { "id": 8, "name": "阿爾巴尼亞", "a2": "al" },
    { "id": 12, "name": "阿爾及利亞", "a2": "dz" },
    { "id": 16, "name": "美屬薩摩亞", "a2": "as" },
    { "id": 20, "name": "安道爾", "a2": "ad" },
    { "id": 24, "name": "安哥拉", "a2": "ao" },
    { "id": 660, "name": "安圭拉", "a2": "ai" },
    { "id": 10, "name": "南極洲", "a2": "aq" },
    { "id": 28, "name": "安地卡及巴布達", "a2": "ag" },
    { "id": 32, "name": "阿根廷", "a2": "ar" },
    { "id": 51, "name": "亞美尼亞", "a2": "am" },
    { "id": 533, "name": "阿魯巴", "a2": "aw" },
    { "id": 36, "name": "澳大利亞", "a2": "au" },
    { "id": 40, "name": "奧地利", "a2": "at" },
    { "id": 31, "name": "亞塞拜然", "a2": "az" },
    { "id": 44, "name": "巴哈馬", "a2": "bs" },
    { "id": 48, "name": "巴林", "a2": "bh" },
    { "id": 50, "name": "孟加拉", "a2": "bd" },
    { "id": 52, "name": "巴貝多", "a2": "bb" },
    { "id": 112, "name": "白俄羅斯", "a2": "by" },
    { "id": 56, "name": "比利時", "a2": "be" },
    { "id": 84, "name": "貝里斯", "a2": "bz" },
    { "id": 204, "name": "貝南", "a2": "bj" },
    { "id": 60, "name": "百慕達", "a2": "bm" },
    { "id": 64, "name": "不丹", "a2": "bt" },
    { "id": 68, "name": "玻利維亞", "a2": "bo" },
    { "id": 535, "name": "荷蘭加勒比區", "a2": "bq" },
    { "id": 70, "name": "波士尼亞與赫塞哥維納", "a2": "ba" },
    { "id": 72, "name": "波札那", "a2": "bw" },
    { "id": 74, "name": "布韋島", "a2": "bv" },
    { "id": 76, "name": "巴西", "a2": "br" },
    { "id": 86, "name": "英屬印度洋領地", "a2": "io" },
    { "id": 96, "name": "汶萊", "a2": "bn" },
    { "id": 100, "name": "保加利亞", "a2": "bg" },
    { "id": 854, "name": "布吉納法索", "a2": "bf" },
    { "id": 108, "name": "蒲隆地", "a2": "bi" },
    { "id": 132, "name": "維德角", "a2": "cv" },
    { "id": 116, "name": "柬埔寨", "a2": "kh" },
    { "id": 120, "name": "喀麥隆", "a2": "cm" },
    { "id": 124, "name": "加拿大", "a2": "ca" },
    { "id": 136, "name": "開曼群島", "a2": "ky" },
    { "id": 140, "name": "中非", "a2": "cf" },
    { "id": 148, "name": "查德", "a2": "td" },
    { "id": 152, "name": "智利", "a2": "cl" },
    { "id": 156, "name": "中國大陸", "a2": "cn" },
    { "id": 162, "name": "聖誕島", "a2": "cx" },
    { "id": 166, "name": "科科斯（基林）群島", "a2": "cc" },
    { "id": 170, "name": "哥倫比亞", "a2": "co" },
    { "id": 174, "name": "葛摩", "a2": "km" },
    { "id": 178, "name": "剛果共和國", "a2": "cg" },
    { "id": 180, "name": "剛果民主共和國", "a2": "cd" },
    { "id": 184, "name": "庫克群島", "a2": "ck" },
    { "id": 188, "name": "哥斯大黎加", "a2": "cr" },
    { "id": 384, "name": "象牙海岸", "a2": "ci" },
    { "id": 191, "name": "克羅埃西亞", "a2": "hr" },
    { "id": 192, "name": "古巴", "a2": "cu" },
    { "id": 531, "name": "古拉索", "a2": "cw" },
    { "id": 196, "name": "賽普勒斯", "a2": "cy" },
    { "id": 203, "name": "捷克", "a2": "cz" },
    { "id": 208, "name": "丹麥", "a2": "dk" },
    { "id": 262, "name": "吉布地", "a2": "dj" },
    { "id": 212, "name": "多米尼克", "a2": "dm" },
    { "id": 214, "name": "多明尼加", "a2": "do" },
    { "id": 218, "name": "厄瓜多", "a2": "ec" },
    { "id": 818, "name": "埃及", "a2": "eg" },
    { "id": 222, "name": "薩爾瓦多", "a2": "sv" },
    { "id": 226, "name": "赤道幾內亞", "a2": "gq" },
    { "id": 232, "name": "厄利垂亞", "a2": "er" },
    { "id": 233, "name": "愛沙尼亞", "a2": "ee" },
    { "id": 748, "name": "史瓦帝尼", "a2": "sz" },
    { "id": 231, "name": "衣索比亞", "a2": "et" },
    { "id": 238, "name": "福克蘭群島", "a2": "fk" },
    { "id": 234, "name": "法羅群島", "a2": "fo" },
    { "id": 242, "name": "斐濟", "a2": "fj" },
    { "id": 246, "name": "芬蘭", "a2": "fi" },
    { "id": 250, "name": "法國", "a2": "fr" },
    { "id": 254, "name": "法屬圭亞那", "a2": "gf" },
    { "id": 258, "name": "法屬玻里尼西亞", "a2": "pf" },
    { "id": 260, "name": "法屬南部和南極領地", "a2": "tf" },
    { "id": 266, "name": "加彭", "a2": "ga" },
    { "id": 270, "name": "甘比亞", "a2": "gm" },
    { "id": 268, "name": "喬治亞", "a2": "ge" },
    { "id": 276, "name": "德國", "a2": "de" },
    { "id": 288, "name": "加納", "a2": "gh" },
    { "id": 292, "name": "直布羅陀", "a2": "gi" },
    { "id": 300, "name": "希臘", "a2": "gr" },
    { "id": 304, "name": "格陵蘭", "a2": "gl" },
    { "id": 308, "name": "格瑞那達", "a2": "gd" },
    { "id": 312, "name": "瓜地洛普", "a2": "gp" },
    { "id": 316, "name": "關島", "a2": "gu" },
    { "id": 320, "name": "瓜地馬拉", "a2": "gt" },
    { "id": 831, "name": "根西", "a2": "gg" },
    { "id": 324, "name": "幾內亞", "a2": "gn" },
    { "id": 624, "name": "幾內亞比索", "a2": "gw" },
    { "id": 328, "name": "蓋亞那", "a2": "gy" },
    { "id": 332, "name": "海地", "a2": "ht" },
    { "id": 334, "name": "赫德島和麥克唐納群島", "a2": "hm" },
    { "id": 336, "name": "梵蒂岡", "a2": "va" },
    { "id": 340, "name": "宏都拉斯", "a2": "hn" },
    { "id": 344, "name": "香港", "a2": "hk" },
    { "id": 348, "name": "匈牙利", "a2": "hu" },
    { "id": 352, "name": "冰島", "a2": "is" },
    { "id": 356, "name": "印度", "a2": "in" },
    { "id": 360, "name": "印尼", "a2": "id" },
    { "id": 364, "name": "伊朗", "a2": "ir" },
    { "id": 368, "name": "伊拉克", "a2": "iq" },
    { "id": 372, "name": "愛爾蘭", "a2": "ie" },
    { "id": 833, "name": "曼島", "a2": "im" },
    { "id": 376, "name": "以色列", "a2": "il" },
    { "id": 380, "name": "義大利", "a2": "it" },
    { "id": 388, "name": "牙買加", "a2": "jm" },
    { "id": 392, "name": "日本", "a2": "jp" },
    { "id": 832, "name": "澤西", "a2": "je" },
    { "id": 400, "name": "約旦", "a2": "jo" },
    { "id": 398, "name": "哈薩克", "a2": "kz" },
    { "id": 404, "name": "肯亞", "a2": "ke" },
    { "id": 296, "name": "吉里巴斯", "a2": "ki" },
    { "id": 408, "name": "北韓", "a2": "kp" },
    { "id": 410, "name": "南韓", "a2": "kr" },
    { "id": 414, "name": "科威特", "a2": "kw" },
    { "id": 417, "name": "吉爾吉斯", "a2": "kg" },
    { "id": 418, "name": "寮國", "a2": "la" },
    { "id": 428, "name": "拉脫維亞", "a2": "lv" },
    { "id": 422, "name": "黎巴嫩", "a2": "lb" },
    { "id": 426, "name": "賴索托", "a2": "ls" },
    { "id": 430, "name": "賴比瑞亞", "a2": "lr" },
    { "id": 434, "name": "利比亞", "a2": "ly" },
    { "id": 438, "name": "列支敦斯登", "a2": "li" },
    { "id": 440, "name": "立陶宛", "a2": "lt" },
    { "id": 442, "name": "盧森堡", "a2": "lu" },
    { "id": 446, "name": "澳門", "a2": "mo" },
    { "id": 450, "name": "馬達加斯加", "a2": "mg" },
    { "id": 454, "name": "馬拉威", "a2": "mw" },
    { "id": 458, "name": "馬來西亞", "a2": "my" },
    { "id": 462, "name": "馬爾地夫", "a2": "mv" },
    { "id": 466, "name": "馬利", "a2": "ml" },
    { "id": 470, "name": "馬爾他", "a2": "mt" },
    { "id": 584, "name": "馬紹爾群島", "a2": "mh" },
    { "id": 474, "name": "馬丁尼克", "a2": "mq" },
    { "id": 478, "name": "茅利塔尼亞", "a2": "mr" },
    { "id": 480, "name": "模里西斯", "a2": "mu" },
    { "id": 175, "name": "馬約特", "a2": "yt" },
    { "id": 484, "name": "墨西哥", "a2": "mx" },
    { "id": 583, "name": "密克羅尼西亞聯邦", "a2": "fm" },
    { "id": 498, "name": "摩爾多瓦", "a2": "md" },
    { "id": 492, "name": "摩納哥", "a2": "mc" },
    { "id": 496, "name": "蒙古", "a2": "mn" },
    { "id": 499, "name": "蒙特內哥羅", "a2": "me" },
    { "id": 500, "name": "蒙特塞拉特", "a2": "ms" },
    { "id": 504, "name": "摩洛哥", "a2": "ma" },
    { "id": 508, "name": "莫三比克", "a2": "mz" },
    { "id": 104, "name": "緬甸", "a2": "mm" },
    { "id": 516, "name": "納米比亞", "a2": "na" },
    { "id": 520, "name": "諾魯", "a2": "nr" },
    { "id": 524, "name": "尼泊爾", "a2": "np" },
    { "id": 528, "name": "荷蘭", "a2": "nl" },
    { "id": 540, "name": "新喀里多尼亞", "a2": "nc" },
    { "id": 554, "name": "紐西蘭", "a2": "nz" },
    { "id": 558, "name": "尼加拉瓜", "a2": "ni" },
    { "id": 562, "name": "尼日", "a2": "ne" },
    { "id": 566, "name": "奈及利亞", "a2": "ng" },
    { "id": 570, "name": "紐埃", "a2": "nu" },
    { "id": 574, "name": "諾福克島", "a2": "nf" },
    { "id": 807, "name": "北馬其頓", "a2": "mk" },
    { "id": 580, "name": "北馬利安納群島", "a2": "mp" },
    { "id": 578, "name": "挪威", "a2": "no" },
    { "id": 512, "name": "阿曼", "a2": "om" },
    { "id": 586, "name": "巴基斯坦", "a2": "pk" },
    { "id": 585, "name": "帛琉", "a2": "pw" },
    { "id": 275, "name": "巴勒斯坦", "a2": "ps" },
    { "id": 591, "name": "巴拿馬", "a2": "pa" },
    { "id": 598, "name": "巴布亞紐幾內亞", "a2": "pg" },
    { "id": 600, "name": "巴拉圭", "a2": "py" },
    { "id": 604, "name": "秘魯", "a2": "pe" },
    { "id": 608, "name": "菲律賓", "a2": "ph" },
    { "id": 612, "name": "皮特凱恩群島", "a2": "pn" },
    { "id": 616, "name": "波蘭", "a2": "pl" },
    { "id": 620, "name": "葡萄牙", "a2": "pt" },
    { "id": 630, "name": "波多黎各", "a2": "pr" },
    { "id": 634, "name": "卡達", "a2": "qa" },
    { "id": 638, "name": "留尼旺", "a2": "re" },
    { "id": 642, "name": "羅馬尼亞", "a2": "ro" },
    { "id": 643, "name": "俄羅斯", "a2": "ru" },
    { "id": 646, "name": "盧安達", "a2": "rw" },
    { "id": 652, "name": "聖巴瑟米", "a2": "bl" },
    { "id": 654, "name": "聖赫倫那、阿森松和特里斯坦-達庫尼亞", "a2": "sh" },
    { "id": 659, "name": "聖克里斯多福及尼維斯", "a2": "kn" },
    { "id": 662, "name": "聖露西亞", "a2": "lc" },
    { "id": 663, "name": "法屬聖馬丁", "a2": "mf" },
    { "id": 666, "name": "聖皮埃與密克隆群島", "a2": "pm" },
    { "id": 670, "name": "聖文森及格瑞那丁", "a2": "vc" },
    { "id": 882, "name": "薩摩亞", "a2": "ws" },
    { "id": 674, "name": "聖馬利諾", "a2": "sm" },
    { "id": 678, "name": "聖多美普林西比", "a2": "st" },
    { "id": 682, "name": "沙烏地阿拉伯", "a2": "sa" },
    { "id": 686, "name": "塞內加爾", "a2": "sn" },
    { "id": 688, "name": "塞爾維亞", "a2": "rs" },
    { "id": 690, "name": "塞席爾", "a2": "sc" },
    { "id": 694, "name": "獅子山", "a2": "sl" },
    { "id": 702, "name": "新加坡", "a2": "sg" },
    { "id": 534, "name": "荷屬聖馬丁", "a2": "sx" },
    { "id": 703, "name": "斯洛伐克", "a2": "sk" },
    { "id": 705, "name": "斯洛維尼亞", "a2": "si" },
    { "id": 90, "name": "索羅門群島", "a2": "sb" },
    { "id": 706, "name": "索馬利亞", "a2": "so" },
    { "id": 710, "name": "南非", "a2": "za" },
    { "id": 239, "name": "南喬治亞和南桑威奇群島", "a2": "gs" },
    { "id": 728, "name": "南蘇丹", "a2": "ss" },
    { "id": 724, "name": "西班牙", "a2": "es" },
    { "id": 144, "name": "斯里蘭卡", "a2": "lk" },
    { "id": 729, "name": "蘇丹", "a2": "sd" },
    { "id": 740, "name": "蘇利南", "a2": "sr" },
    { "id": 744, "name": "斯瓦爾巴和揚馬延", "a2": "sj" },
    { "id": 752, "name": "瑞典", "a2": "se" },
    { "id": 756, "name": "瑞士", "a2": "ch" },
    { "id": 760, "name": "敘利亞", "a2": "sy" },
    { "id": 158, "name": "台灣", "a2": "tw" },
    { "id": 762, "name": "塔吉克", "a2": "tj" },
    { "id": 834, "name": "坦尚尼亞", "a2": "tz" },
    { "id": 764, "name": "泰國", "a2": "th" },
    { "id": 626, "name": "東帝汶", "a2": "tl" },
    { "id": 768, "name": "多哥", "a2": "tg" },
    { "id": 772, "name": "托克勞", "a2": "tk" },
    { "id": 776, "name": "東加", "a2": "to" },
    { "id": 780, "name": "千里達及托巴哥", "a2": "tt" },
    { "id": 788, "name": "突尼西亞", "a2": "tn" },
    { "id": 792, "name": "土耳其", "a2": "tr" },
    { "id": 795, "name": "土庫曼", "a2": "tm" },
    { "id": 796, "name": "特克斯與凱科斯群島", "a2": "tc" },
    { "id": 798, "name": "吐瓦魯", "a2": "tv" },
    { "id": 800, "name": "烏干達", "a2": "ug" },
    { "id": 804, "name": "烏克蘭", "a2": "ua" },
    { "id": 784, "name": "阿聯", "a2": "ae" },
    { "id": 826, "name": "英國", "a2": "gb" },
    { "id": 840, "name": "美國", "a2": "us" },
    { "id": 581, "name": "美國本土外小島嶼", "a2": "um" },
    { "id": 858, "name": "烏拉圭", "a2": "uy" },
    { "id": 860, "name": "烏茲別克", "a2": "uz" },
    { "id": 548, "name": "萬那杜", "a2": "vu" },
    { "id": 862, "name": "委內瑞拉", "a2": "ve" },
    { "id": 704, "name": "越南", "a2": "vn" },
    { "id": 92, "name": "英屬維京群島", "a2": "vg" },
    { "id": 850, "name": "美屬維京群島", "a2": "vi" },
    { "id": 876, "name": "瓦利斯和富圖那", "a2": "wf" },
    { "id": 732, "name": "西撒哈拉", "a2": "eh" },
    { "id": 887, "name": "葉門", "a2": "ye" },
    { "id": 894, "name": "尚比亞", "a2": "zm" },
    { "id": 716, "name": "辛巴威", "a2": "zw" }
  ]
}